module.exports = __webpack_public_path__ + "static/media/hg_logo_v5_1.744bedb5.svg";